<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';

function recoverStuckRouterInteractivity() {
  if (typeof document === 'undefined') return;

  const outlets = Array.from(document.querySelectorAll('ion-router-outlet')) as HTMLElement[];
  for (const outlet of outlets) {
    if (outlet.style.pointerEvents === 'none') {
      outlet.style.pointerEvents = '';
    }

    const pages = Array.from(outlet.querySelectorAll('.ion-page')) as HTMLElement[];
    if (!pages.length) continue;

    const activePage = [...pages].reverse().find((page) => !page.classList.contains('ion-page-hidden')) ?? pages[pages.length - 1];
    if (!activePage) continue;

    if (activePage.classList.contains('ion-page-invisible')) {
      activePage.classList.remove('ion-page-invisible');
    }
    if (activePage.style.pointerEvents === 'none') {
      activePage.style.pointerEvents = 'auto';
    }
  }
}

function onVisibilityResume() {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
  requestAnimationFrame(() => {
    recoverStuckRouterInteractivity();
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('swipewish:app-foreground'));
  });
}

onMounted(() => {
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisibilityResume);
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('focus', onVisibilityResume);
    window.addEventListener('pageshow', onVisibilityResume);
  }
});

onUnmounted(() => {
  if (typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', onVisibilityResume);
  }
  if (typeof window !== 'undefined') {
    window.removeEventListener('focus', onVisibilityResume);
    window.removeEventListener('pageshow', onVisibilityResume);
  }
});
</script>
